module.exports = __webpack_public_path__ + "img/mirna-anzaldo.19cb3eea.jpg";